<div class="container-fluid py-n2" style="max-width: 700px; height: auto;">
  <div class="row bg-white rounded p-2 border flex-column flex-md-row">
    
    <!-- Profile Section -->
    <div class="col-12 d-flex align-items-center mb-3">
      <img [src]="data.data[0]?.Owner?.profilePicture" 
        class="rounded-circle me-1 img-fluid" 
        style="width: 70px; height: 70px;" 
        alt="Profile Image" (click)="openModal(data.data[0]?.Owner?.profilePicture)">

      <div class="d-flex flex-column">
        <button (click)="redirectToCitizenProfile()" class="btn">
          <div class="fw-bold text-primary">
            {{ data.data[0]?.Owner?.name }}
          </div>
        </button>
        <small class="text-warning fw-semibold small mb-0 ms-3">{{ data.data[0]?.Owner?.type === 'User' ? 'Citizen' : data.data[0]?.Owner?.type }}</small>
        <p class="text-muted small mb-0 ms-3"><i class="bi bi-calendar"></i>&nbsp;&nbsp;{{ data.data[0]?.created | date }}</p>
      </div>

      <!-- Status & Share Buttons -->
      <div class="ms-auto d-flex flex-wrap">
        <button class="btn btn-outline-secondary btn-sm me-2" (click)="toggleButtonClick('status')">
          <i *ngIf="config.useIcons" class="bi bi-check-circle"></i>
          <span *ngIf="!config.useIcons">{{ data.data[0]?.status || 'Status' }}</span>
        </button>
      </div>
    </div>

    <!-- News Image -->
    <div class="col-12 mb-3">
      <div class="ratio ratio-1x1 rounded">
        <img [src]="data.data[0]?.image" class="img-fluid rounded" alt="News Image" (click)="openModal(data.data[0]?.image)">
      </div>
    </div>

    <!-- Content Section -->
    <div class="col-12">
      <h5 class="fw-bold">{{ data.data[0]?.title }}</h5>
      <p class="text-muted">{{ data.data[0]?.description }}</p>

      <!-- Tags -->
      <div class="mb-3">
        <span><i class="bi bi-list" *ngIf="data.data[0]?.category"></i> {{ data.data[0]?.category }}</span>
        <span><i class="bi bi-tag ms-2" *ngIf="data.data[0]?.type"></i> {{ data.data[0]?.type }}</span>
        <span><i class="bi bi-geo-alt ms-2" *ngIf="data.data[0]?.Owner?.address?.location"></i> {{ data.data[0]?.Owner?.address?.location }}</span>
      </div>

      <!-- Like, Dislike, Comment Buttons -->
      <div class="d-flex align-items-center mb-2 mt-1 flex-wrap">
        <button class="btn btn-sm" (click)="toggleButtonClick('like')">
          <i class="bi text-success" [ngClass]="{'bi-hand-thumbs-up-fill': isLiked, 'bi-hand-thumbs-up': !isLiked}"></i>
          &nbsp;<span>{{ data.data[0]?.LikeDislikeSummary?.likes}}</span>
        </button>
        <button class="btn btn-sm" (click)="toggleButtonClick('dislike')">
          <i class="bi text-danger" [ngClass]="{'bi-hand-thumbs-down-fill': isDisliked, 'bi-hand-thumbs-down': !isDisliked}"></i>
          &nbsp;<span>{{ data.data[0]?.LikeDislikeSummary?.dislikes}}</span>
        </button>
        <div class="ms-auto d-flex flex-wrap">
          <button class="btn btn-sm" (click)="openCommentModal($event)">
            <span>{{data.data[0]?.ratings?.comments}}</span>
          </button>
          <button class="btn btn-sm" (click)="onShareClick($event)">
            <i class="bi bi-share"></i>
            <span *ngIf="!config?.useIcons">{{ data.data[0]?.share }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer Spacer to Avoid Hidden Content -->
<div class="container py-4" style="max-width: 700px; width: 100%; height:200px;"></div>
